import { sanitizeDocumentHtml } from "./sanitizeHtml";

export const extractPrintableHtml = (payload) => {
  if (!payload) return null;
  if (typeof payload === "string") {
    return payload.trim() ? payload : null;
  }
  const html = payload.data ?? payload.html ?? payload.content;
  return typeof html === "string" && html.trim() ? html : null;
};

export const openPrintWindow = (html) => {
  const safeHtml = sanitizeDocumentHtml(html);

  const iframe = document.createElement("iframe");
  iframe.setAttribute("aria-hidden", "true");
  iframe.style.position = "fixed";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";
  document.body.appendChild(iframe);

  const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
  iframeDoc.open();
  iframeDoc.write(
    /<html[\s>]/i.test(safeHtml)
      ? safeHtml
      : `<!doctype html><html><body>${safeHtml}</body></html>`
  );
  iframeDoc.close();

  setTimeout(() => {
    try {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    } finally {
      document.body.removeChild(iframe);
    }
  }, 300);
};
